import { FindingsOverview } from "@/components/aicheck/FindingsOverview";
import type { ActiveTab } from "@/components/aicheck/hooks/useTraceabilityHistory";
import type { AICheckRunResult } from "@/types/aicheck";

interface FindingsTabProps {
  result: AICheckRunResult;
  activeTab: ActiveTab;
}

/**
 * 「指摘一覧」タブ本体。tabpanel ラッパ + FindingsOverview。
 * FindingsOverview はアクティブ時のみマウントする（元実装の遅延描画を維持）。
 */
export function FindingsTab({ result, activeTab }: FindingsTabProps) {
  return (
    <div
      id="results-panel-findings"
      role="tabpanel"
      aria-labelledby="results-tab-findings"
      hidden={activeTab !== "findings"}
    >
      {activeTab === "findings" && <FindingsOverview result={result} />}
    </div>
  );
}
